<template>
    <div>
      <div class="name-container" :data-relevancy-score="relevancyScore" :data-cost-rating="costRating" :data-quality-rating="qualityRating">
        <div class="heading-style">
          <img alt="HealthPartners logo" src="../../../assets/images/hp-logomark-rgb.png" v-if="location.hpmgLocation" />
          <hp5-heading size-selection="md" tag-selection="h3">
            <hp5-link-text-basic size="md">
              <a :data-card-rank="rank" :href="detailUrl">{{ name }}</a>
            </hp5-link-text-basic>
          </hp5-heading>
        </div>
        <div class="popover">
          <ResultsBaseLowCostRatingPopoverMessage :result="location"/>
      </div>
      </div>
    </div>
</template>
  
<script setup>

    const props = defineProps({
        location: Object,
        rank: Number
    })

     // adding this info to data attributes so QA's can use the UI to test
    const relevancyScore = ref(props.location.relevancyScore)
    const costRating = props.location.costRating ? ref(props.location.costRating.value) : ''
    const qualityRating = props.location.qualityRating ?  ref(props.location.qualityRating.value) : ''

    const { profile, context, betterChoiceContext } = useFCPModel()
    const { locationDetailUrl } = useUrls(context.value)

    const name = computed(() => props.location.name )
    const detailUrl = computed(() => locationDetailUrl(props.location.id, betterChoiceContext.value))

</script>
  
<style lang="scss" scoped>
  .name-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  
  hp5-heading,
  img {
    display: inline-block;
  }
  
  img {
    height: var(--text-heading-line-height-md);
    margin-right: var(--spacing-xxs);
  }

  .title {
    display: grid;
    justify-content: space-between;
    align-items: center;
}

.heading-style{
  grid-column: 1;
}
.popover {
    font-family: var(--text-heading-font-md);
    grid-column: 2;
    grid-row: 1;
}
</style>

<style lang="scss">

.name-container {
  hp5-link-text-basic .hp-link-text-basic {
    color: var(--color-text-base);
    text-decoration: none;
    font-family: var(--text-heading-font-md);
    font-weight: var(--text-heading-weight-md);
    font-size: var(--text-heading-pixels-md);
    line-height: var(--text-heading-line-height-md);
    letter-spacing: var(--text-heading-letter-spacing-md);

    
  }

  &:hover {
      hp5-link-text-basic {
        a {
          color: var(--color-link-dark);
        }
      }
  }
}

</style>